/**
 * eventid.jsx
 * import axios for server calls
 * import Form is used for form fields and styling
 * import Button is the button field from react bootstrap
 * import Row and Col from react bootstrap for organizing display
 * import ErrorMessage for displaying error messages
 * import SuccMessage for displaying succ messages
 * import QRcode for creating qr codes
 * import ChangeTime = function for converting time from 24 to 12 hour
 * import Nav from reactbootstrap for nav creation
 * import Message for displaying contact's rsvp messages
 * import moment for date conversion
 */
import React, {useState, useEffect} from 'react';
import Button from 'react-bootstrap/Button';
import axios from 'axios';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import QRcode from "qrcode";
import ChangeTime from '../Misc/changeTime';
import SuccMessage from '../Misc/succMessage';
import ErrorMessage from '../Misc/ErrorMessage';
import { useParams, useHistory } from 'react-router-dom';
import '../../style/eventDetails.css';
import Nav from 'react-bootstrap/Nav';
import { Form, Tab } from 'react-bootstrap';
import AssignContact from './AssignContact';
import EventContact from './eventContact';
import Message from '../Misc/message';
import EmailForm from './emailForm';
import Moment from 'moment';


function Eventid () {
    const [src, setSrc] = useState('');
    const [succMesg, setSuccMesg] = useState('');
    const [errorMesg, setErrorMesg] = useState("");
    const [eventDets, setEventDets] = useState("");
    const {eventid} = useParams();
    const [contacts, setContacts] = useState([]);
    const [eventContacts, setEventContacts] = useState([]);
    const [date, setDate] = useState("");
    const [loc, setLoc] = useState("");
    const [time, setTime] = useState("");
    const [mesg, setMesg] = useState("");
    const [message, setMessage] = useState([]);
    const [noMessage, setNoMessage] = useState(false);
    const history = useHistory();

    let today = new Date();
    let dd = today.getDate();
    let mm = today.getMonth() + 1;
    let yyyy = today.getFullYear();
    let hour = today.getHours();
    let minutes = today.getMinutes();
    const dateNew = Moment(eventDets.name).format('MM-DD-YYYY');

    QRcode.toDataURL(`https://link2rsvp.netlify.app/eventqrcode/${eventDets.title}/${eventDets.time}/
    ${eventDets.name}/${eventDets.location}/${eventDets._id}`).then((setSrc));

    if(hour<10) {
        hour='0'+hour;
    }
    if(minutes<10){
        minutes='0'+minutes;
    }
    if(dd<10) {
        dd='0'+dd;
    }
    if(mm<10) {
        mm='0'+mm
    }

    today = yyyy+'-'+mm+'-'+dd;
    /**
     * function ChangeTime 
     * @param time = an event time
     * changes time from 24 hour to 12 hour
     * @returns converted time
     */
    function changeTime(time) {
        if(time) {
            //splits time spring between ":"
            var timeArray = time.split(':');
            //if the hour is less greater than 12, then hour is hour - 12 (pm)
            if(timeArray[0] > 12) {
                timeArray[0] = timeArray[0] - 12;
                return timeArray[0]+":"+timeArray[1]+"pm";
            //if the hour is 12 then the hour stays as 12
            } else if (timeArray[0] === "12") {
                return timeArray[0]+':'+timeArray[1]+'pm';
            }else {
                //if the hour is 00, then the new hour is 12 (am)
                if(timeArray[0] === "00") {
                    timeArray[0] = 12;
                    return timeArray[0]+':'+timeArray[1]+'am';
                //else if hour is less than 12 then hour stays the same (am)
                } else if(timeArray[0] >= 10 && timeArray[0] <= 11) {
                    return timeArray[0]+':'+timeArray[1]+'am';
                } else {
                    var delZero = timeArray[0].split("");
                    return delZero[1]+":"+timeArray[1]+'am';
                }
            }
        }
    }
    changeTime(eventDets.time);
    /**
     * function getEvent()
     * gets event details
     */
    async function getEvent() {
        const event = await axios.get(`https://link2rsvp.herokuapp.com/event/eventdetails/${eventid}`);
        setEventDets(event.data);
    }
    /**
     * gets all user's contacts
     */
    async function getContacts() {
        const contactRes = await axios.get('https://link2rsvp.herokuapp.com/contact');
        setContacts(contactRes.data);
    }
    /**
     * gets contacts that have been invited to event
     */
    async function getEventContacts() {
        const eventContact = await axios.get(`https://link2rsvp.herokuapp.com/contact/${eventid}`);
        setEventContacts(eventContact.data);
    }
    /**
     * function getMessage()
     * gets rsvp messages for event
     */
    async function getMessage() {
        try {
            //gets messages from database
            const mesgRes = await axios.get(`https://link2rsvp.herokuapp.com/event/getMessages/${eventid}`);
            setMessage(mesgRes.data);
            //decides if messages is empty
            if(mesgRes.data.length > 0){
                setNoMessage(false);
            } else {
                setNoMessage(true);
            }
        } catch (err) {
            if(err.response) {
                if(err.response.data.errorMessage) {
                    console.log(err.reponse.data.errorMessage);
                }
            }
        }
    }
    /**
     * function upDate()
     * Called when updating an event
     * takes in new event details,
     * sends them to server to be saved
     */
    async function upDate(e) {
        e.preventDefault();
        //getting current time for update message
        let today = new Date();
        let hour = today.getHours();
        if(hour < 10) {
            hour = '0'+hour;
        }
        let minutes = today.getMinutes();
        if(minutes < 10){
            minutes = '0'+minutes;
        }
        const timeCurrent = hour+':'+minutes;
        const update = {
            date: date,
            time: time,
            mesg: mesg,
            loc: loc,
            id: eventDets._id
        }

        const mesgData = {
            eventid: eventDets._id,
            contactid: "0",
            message: "New Event Details: \n Date: " + date + "\n Time: " + ChangeTime(time) +
                        "\n location: " + loc + "\n Message: " + mesg,
            time: timeCurrent
        };
        //sending update message and sending new event information to server
        try {
            const response = await axios.put('https://link2rsvp.herokuapp.com/event/update', update);
            await axios.post("https://link2rsvp.herokuapp.com/event/message", mesgData);
            getEvent();
            setSuccMesg(response.data.succMessage);
            setMesg("");
        } catch (err) {
            if(err.response) {
                if(err.response.data.errorMessage) {
                    setErrorMesg(err.response.data.errorMessage);
                }
            }
        }

    }
    /**
     * function copyBoard()
     * called when copy button is pressed
     * copys event qrocde link to board
     */
    function copyBoard() {
        navigator.clipboard.writeText(`https://link2rsvp.netlify.app/eventqrcode/${eventDets.title}/${eventDets.time}/
        ${eventDets.name}/${eventDets.location}/${eventDets._id}`);
    }
    /**
     * function deleteEvent()
     * Called when cancel/delete event button is clicked
     * deletes an event from the database
     */
    async function deleteEvent() {
        try {
        await axios.delete(`https://link2rsvp.herokuapp.com/event/${eventDets._id}`);
        history.push("/home");
        } catch (err) {
            if(err.response) {
                if(err.response.data.errorMessage) {
                    setErrorMesg(err.response.data.errorMessage);
                }
            }
        }
    }

    useEffect(() => {
        getContacts();
        getEventContacts();
        getEvent();
        //eslint-disable-next-line react-hooks/exhaustive-deps
    },[eventid]);

    useEffect(() => {
        setDate(eventDets.name);
        setLoc(eventDets.location);
        setTime(eventDets.time);
    },[eventDets]);
    
    
    return (
        <div>
            <div className="event-div">
                <h2 className="title" style={{backgroundColor: "#890E32",color: "white"}}>{eventDets.title}</h2>
           <Tab.Container id="left-taps-example" defaultActiveKey="first" bg="dark">
               <Row>
                   <Col sm={2}>
                       <Nav variant="pills" className="flex-column">
                       <Nav.Item>
                           <Nav.Link eventKey="first" className="navBar" onClick={getEvent}>Details</Nav.Link>
                       </Nav.Item>
                       <Nav.Item>
                           <Nav.Link eventKey="second" className="navBar">Edit</Nav.Link>
                       </Nav.Item>
                       <Nav.Item>
                           <Nav.Link eventKey="third" className="navBar" onClick={getContacts}>Invite</Nav.Link>
                       </Nav.Item>
                       <Nav.Item>
                           <Nav.Link eventKey="fourth" className="navBar">QR Code</Nav.Link>
                       </Nav.Item>
                       <Nav.Item>
                           <Nav.Link eventKey="fifth" className="navBar">Email Guests</Nav.Link>
                       </Nav.Item>
                       <Nav.Item>
                           <Nav.Link eventKey="sixth" className="navBar" onClick={getMessage}>Rsvp Messages</Nav.Link>
                       </Nav.Item>
                       </Nav>
                   </Col>
                   <Col>
                       <Tab.Content>
                           <Tab.Pane eventKey="first">
                               {
                                   errorMesg && (
                                       <ErrorMessage
                                       message={errorMesg}
                                       clear={() => setErrorMesg(null)}
                                       />
                                   )
                               }
                               <Row>
                               <Col className="eventDetails-tab">
                               {<p><span className="details-tag">Date: </span><span>{dateNew}</span></p>}
                               {<p><span className="details-tag">Time: </span><span>{changeTime(eventDets.time)}</span></p>}
                               {<p><span className="details-tag">Location: </span><span>{eventDets.location}</span></p>}
                               </Col>
                               <Col className="eventDetails-tab">
                               {<p><span className="details-tag">Description: </span><span>{eventDets.description}</span></p>}
                               {eventDets.vaxReq ? <p><span className="details-tag">Coivd Vaccine Required: </span><span>Yes</span></p>:
                               <p><span className="details-tag">Coivd Vaccine Required: </span><span>No</span></p>}
                               {<p><span className="details-tag">Attending: </span><span>{eventDets.attendNumber} out of {eventDets.rsvpLimit}</span></p>}
                               </Col>
                               </Row>
                               <Button onClick={deleteEvent} variant="dark" style={{backgroundColor: "black"}} id="delete-btn">{eventDets.name > today ? 'Cancel Event' : 'Delete Event'}</Button>
                           </Tab.Pane>
                       </Tab.Content>
                       <Tab.Content>
                           <Tab.Pane eventKey="second">
                                {
                                   errorMesg && (
                                       <ErrorMessage
                                       message={errorMesg}
                                       clear={() => setErrorMesg(null)}
                                       />
                                   )
                               }
                                <form onSubmit={upDate} id="upDate-form">
                                {
                                    succMesg && (
                                    <SuccMessage
                                    message={succMesg}
                                    clear={() => setSuccMesg(null)}
                                    />
                                    )
                                }
                                    <Row>
                                        <Col>
                                            <Form.Group className="mb-3">
                                                <label htmlFor="editEventDate">Date:</label>
                                                <Form.Control
                                                id="editEventDate"
                                                type="date"
                                                max="2023-12-31"
                                                min={today}
                                                value={date ?? ""}
                                                onChange={(e) => setDate(e.target.value)}
                                                required
                                                />
                                            </Form.Group>
                                            <Form.Group className="mb-3">
                                                <label htmlFor="editEventLoc">Location:</label>
                                                <Form.Control
                                                id="editEventLoc"
                                                type="text"
                                                value={loc ?? ""}
                                                pattern="[A-Za-z0-9\s']+"
                                                title="please use a-z, A-z, and 0-9"
                                                onChange={(e) => setLoc(e.target.value)}
                                                required
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group className="mb-3" id="edit">
                                                <label htmlFor="editEventTime">Time:</label>
                                                <Form.Control
                                                id="editEventTime"
                                                type="time"
                                                value={time ?? ""}
                                                onChange={(e) => setTime(e.target.value)}
                                                />
                                            </Form.Group>
                                            <Form.Group className="mb-3" id="edit">
                                                <label htmlFor="editEventMsg">Message to invited guest</label>
                                                <Form.Control as="textarea" rows={1}
                                                id="editEventMsg"
                                                type="text"
                                                value={mesg}
                                                onChange={(e) => setMesg(e.target.value)}
                                                required
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Button variant="secondary" type="submit" id="update-btn">Update Event</Button>
                                </form>
                           </Tab.Pane>
                       </Tab.Content>
                       <Tab.Content>
                           <Tab.Pane eventKey="third">
                               <Row>
                                   <Col>
                                    <h4 style={{textAlign: 'center'}}>Contacts</h4>
                                   <Form.Text className="text-muted" style={{textAlign: 'center'}}>Add and Delete Contacts by Checking</Form.Text>
                                   <div style={{height: 150, overflowY: 'scroll'}} className="scroll-div">
                                       {contacts.map((contact, i) => {return <AssignContact
                                       key={i}
                                       contact={contact}
                                       eventID={eventid}
                                       getEventContacts={getEventContacts}
                                       />})}
                                    </div>
                                    </Col>
                                    <Col>
                                    <h4 style={{textAlign: 'center'}}>Invited Contacts</h4>
                                    <Form.Text className="text-muted">&#10003; = rsvped</Form.Text>
                                    <div style={{height: 150, overflowY: 'scroll'}} className="scroll-div">
                                    {eventContacts.map((contact,i) => {return <EventContact key={i}
                                    contact={contact}
                                    eventid={eventid}
                                    getEventContacts={getEventContacts}
                                    />})}
                                    </div>
                                    </Col>
                                </Row>
                           </Tab.Pane>
                       </Tab.Content>
                       <Tab.Content>
                           <Tab.Pane eventKey="fourth">
                               <Row>
                                   <Col>
                               <p>Click the Qr code to Download!</p>
                               <a href={src} download>
                                   <img src={src} alt={eventDets.title} id="qr-code"/>
                                </a>
                                   </Col>
                                   <Col>
                                   <span>Qr Code URL:<button style={{backgroundColor: "#890E32"}} title="Copy to Clipboard" onClick={copyBoard}><span role="img" aria-label="clip">&#128203;</span></button>
                                       <br></br>
                                       <a id="qrlink"href={`https://link2rsvp.netlify.app/eventqrcode/${eventDets.title}/${eventDets.time}/
                                            ${eventDets.name}/${eventDets.location}/${eventDets._id}`}>{`https://link2rsvp.netlify.app/eventqrcode/${eventDets.title}/${eventDets.time}/
                                            ${eventDets.name}/${eventDets.location}/${eventDets._id}`}</a></span>
                                   </Col>
                                </Row>
                           </Tab.Pane>
                       </Tab.Content>
                       <Tab.Content>
                           <Tab.Pane eventKey="fifth">
                               <div style={{width: "50%", marginLeft: "20%"}}>
                                    <p>Send an email message to your invited contacts.</p>
                                    <EmailForm eventDetails={eventDets} />
                                </div>
                           </Tab.Pane>
                       </Tab.Content>
                       <Tab.Content>
                           <Tab.Pane eventKey="sixth">
                                <h4 style={{textAlign: "center"}}>Guests Rsvp Messages</h4>
                                <div>
                                    <div style={{height: 250,
                                                overflowY: 'scroll',
                                                backgroundColor: "rgb(300,300,300)"}} 
                                                className="message-div"
                                                id="scroll-div"
                                                >
                                        {
                                            message.map((message, i) => {return <Message key={i}
                                                                                         message={message}
                                                                                         contactid="0"
                                                                                         />})
                                        }
                                        {
                                            noMessage && (
                                                <p style={{margin: "auto", textAlign: "center"}}>No Messages Currently</p>
                                            )
                                        }
                                    </div>
                                </div>
                           </Tab.Pane>
                       </Tab.Content>
                   </Col>
               </Row>
           </Tab.Container>
           </div>
        </div>
    );
}

export default Eventid;